import { money, pageInfo } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const GetChargeCardPaymentHistory = gql`
  query GetChargeCardPaymentHistory($after: String, $first: Int) {
    myAccounts {
      chargeCard {
        id
        status
        routingNumber
        iconUrl
        nickname
        paymentHistory(after: $after, first: $first) {
          edges {
            cursor
            node {
              id
              isCancellable
              status
              date
              amount {
                ...money
              }
              details {
                id
                title
                ... on IDetailCopyItem {
                  copy
                }
              }
            }
          }
          pageInfo {
            ...pageInfo
          }
        }
      }
    }
  }
  ${money}
  ${pageInfo}
`;

export default GetChargeCardPaymentHistory;
